module.exports = __webpack_public_path__ + "/build/web/svg/ic_trash-white.9e17042b4c1ca84278ff173130bedef0.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/ic_trash-white.svg
// module id = 98
// module chunks = 13